import { render } from "./UiProgress.vue?vue&type=template&id=6e7a83ee&ts=true"
import script from "./UiProgress.vue?vue&type=script&lang=ts"
export * from "./UiProgress.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__